import { VideoV1 } from '@ilteducation/content-registry-types';

export const getTitle = (video: VideoV1) => {
  const titleSv = video.title.find((t) => t.languageCode.startsWith('sv'))?.value;
  if (titleSv) {
    return titleSv;
  }
  return video.title && video.title.length > 0 ? video.title[0].value : '';
};
